import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { IconTile } from '@atlaskit/icon';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import Tile from '@atlaskit/tile';
import { token } from '@atlaskit/tokens';
import { Text } from '@atlaskit/primitives/compiled';

import { usePageSpaceKey } from '@confluence/page-context';
import { fg } from '@confluence/feature-gating';

import { buildCreationLink } from '../CreateContentRouteComponent/createContentRouteUtils.ts';

import { ContentTreeOnboardingItem, SOURCE_NAME } from './ContentTreeOnboardingItem.tsx';

export const CreateWhiteboardOnboardingItem = () => {
	const [spaceKey] = usePageSpaceKey();

	const createWhiteboardLink = buildCreationLink({
		contentType: 'whiteboard',
		source: SOURCE_NAME,
		spaceKey,
	});

	return (
		<ContentTreeOnboardingItem
			href={createWhiteboardLink}
			iconGlyph={
				fg('confluence_frontend_tile_object_system_migration') ? (
					<Tile label="">
						<WhiteboardIcon color={token('color.text.inverse')} label="" />
					</Tile>
				) : (
					<IconTile
						icon={() => <WhiteboardIcon label="" color={token('color.text.inverse')} />}
						appearance="tealBold"
						label=""
						size="24"
					/>
				)
			}
			contentType="whiteboard"
		>
			<Text maxLines={1} color="color.text.subtle">
				<FormattedMessage {...i18n.addYourFirstWhiteboard} />
			</Text>
		</ContentTreeOnboardingItem>
	);
};

const i18n = defineMessages({
	addYourFirstWhiteboard: {
		id: 'create-blank-fabric-page.content-tree-onboarding.new-whiteboard',
		defaultMessage: 'Add your first whiteboard',
		description: 'Text shown in empty content tree which prompts user to create a new whiteboard.',
	},
});
